import { useSelector } from 'react-redux';

import Grid from '@anwb/poncho/components/grid';
import Notification from '@anwb/poncho/components/notification';
import Typography from '@anwb/poncho/components/typography';

import { isFlexSelector } from '../../../../store/selectors';
import {
	DATA_MISSING_ERROR_MESSAGE,
	searchAndFilterPrivateLeaseFlexUrl,
	searchAndFilterPrivateLeaseUrl,
} from '../../../../utils/constants';
import { RequestFlowTitle } from '../../RequestFlow.styled';

type Props = {
	errorMessage: string;
};

export const ErrorMessagePage = ({ errorMessage }: Props) => {
	const isFlex = useSelector(isFlexSelector);
	return (
		<Grid justify="center" constrainedWidth>
			<Grid.Item>
				<RequestFlowTitle variant="page-title" data-test="request-flow-title">
					Maandbedrag Private Lease {isFlex ? 'Flex' : ''} berekenen
				</RequestFlowTitle>
			</Grid.Item>
			<Grid.Item inline fullWidth>
				<Notification title={errorMessage} variant="error">
					Bekijk het volledige{' '}
					{isFlex ? (
						<Typography variant="link-text" href={searchAndFilterPrivateLeaseFlexUrl()}>
							ANWB Private Lease Flex
						</Typography>
					) : (
						<Typography variant="link-text" href={searchAndFilterPrivateLeaseUrl()}>
							ANWB Private Lease
						</Typography>
					)}{' '}
					aanbod
					{errorMessage === DATA_MISSING_ERROR_MESSAGE ? ' of probeer het later nog een keer' : ''}.
				</Notification>
			</Grid.Item>
			<Grid.Aside>
				<div />
			</Grid.Aside>
		</Grid>
	);
};
